'use client';

import React from 'react';
import { motion } from 'framer-motion';

const GOLD_ACCENT = '#faaf40';
const SHADOW_GOLD = 'rgba(250, 175, 64, 0.4)';

export default function MembershipHeroSection() {
  const scrollToPlans = () => {
    const element = document.getElementById('plans');
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section 
      className="relative flex items-center justify-center min-h-[75vh] bg-black overflow-hidden"
      style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1593079831268-3381b0db4a77?q=80&w=2070&auto=format&fit=crop')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-black" />
      
      <div className="relative z-10 text-center text-white px-6 max-w-4xl mx-auto">
        <motion.span 
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-[9px] sm:text-[10px] uppercase tracking-[0.6em] mb-4 block font-bold text-[#faaf40] opacity-80"
        >
          Precision Science • Organic Flow
        </motion.span>

        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-3xl sm:text-5xl md:text-6xl font-black uppercase tracking-tighter leading-[1.1] italic"
        >
          INVEST IN <br />
          <span style={{ color: GOLD_ACCENT, textShadow: `0 0 10px ${SHADOW_GOLD}` }} className="not-italic">
            YOUR HEALTH
          </span>
        </motion.h1>

        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="mt-6 space-y-4"
        >
          <p className="text-sm sm:text-base md:text-lg font-light text-zinc-300 max-w-2xl mx-auto leading-relaxed">
            Aura gives you technology, tracking, and results—compressed into 20 minutes that actually fit your life.
          </p>
          
          <div className="pt-2">
            <p className="text-[10px] sm:text-[11px] text-zinc-500 max-w-xl mx-auto font-medium uppercase tracking-[0.3em] opacity-70">
              Transparent Membership Plans • Islamabad Sanctuary
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="mt-12"
        >
          <motion.button 
            onClick={scrollToPlans}
            whileHover={{ 
              scale: 1.05,
              boxShadow: `0 0 25px rgba(250, 175, 64, 0.3)`,
            }}
            whileTap={{ scale: 0.98 }}
            className="relative group px-10 py-4 rounded-full overflow-hidden transition-all duration-500"
            style={{ 
              border: `1px solid ${GOLD_ACCENT}60`, 
              background: 'rgba(0,0,0,0.2)',
              backdropFilter: 'blur(8px)'
            }}
          >
            {/* The Liquid Gold Fill */}
            <div 
              className="absolute inset-0 translate-y-[101%] group-hover:translate-y-0 transition-transform duration-500 ease-out z-0"
              style={{ backgroundColor: GOLD_ACCENT }}
            />

            {/* Button Text - Color changes from Gold to Black on hover */}
            <span 
              className="relative z-10 flex items-center justify-center gap-3 text-[10px] font-black uppercase tracking-[0.3em] transition-colors duration-500 text-[#faaf40] group-hover:text-black"
            >
              Explore Tiers
              <motion.span
                animate={{ x: [0, 5, 0] }}
                transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
                className="text-lg leading-none"
              >
                →
              </motion.span>
            </span>

            <div className="absolute inset-0 border border-white/5 rounded-full group-hover:border-transparent transition-colors" />
          </motion.button>
        </motion.div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-black to-transparent pointer-events-none" />
    </section>
  );
}